import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const RequiredIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 10 10" {...props}>
    <path d="M0 4.71154L0.695915 2.4359C2.29954 3.03421 3.46444 3.55237 4.19062 3.99038C3.99899 2.05665 3.89813 0.726519 3.88805 0H6.08169C6.05143 1.05772 5.93544 2.3825 5.73374 3.97436C6.77256 3.41882 7.96267 2.906 9.30408 2.4359L10 4.71154C8.7191 5.16027 7.46343 5.45942 6.23298 5.60897C6.8482 6.17523 7.71557 7.18485 8.8351 8.63782L7.01967 10C6.43469 9.156 5.74382 8.00749 4.94705 6.55449C4.2007 8.06091 3.54513 9.20942 2.98033 10L1.19516 8.63782C2.3651 7.11006 3.20221 6.10045 3.70651 5.60897C2.40544 5.3419 1.16994 5.04275 0 4.71154Z" />
  </SvgIcon>
);
